module.exports = __webpack_public_path__ + "img/top-logo.04a8ace.png";